import React, { FunctionComponent, RefObject } from 'react';
import styled from 'styled-components';
import { MenuListItem } from '../components/MenuListItem';
import { MenuSeeAllOption } from '../components/MenuSeeAllOption';
import { MenuThematicsOptions } from '../components/MenuThematicsOptions';
import { DisplayMode } from '../desktop/MenuDesktopContent';
import { MenuItem, ROOT_PRODUCTS_KEY, ROOT_THEMATICS_KEY, sortItems, SortType } from '../MenuUtils';
import rightChevron from '../../../../assets/icons/chevron-right.svg';

interface Props {
  item: MenuItem;
  menuSelectedPath: MenuItem[];
  setMenuSelectedPath: (menuItems: MenuItem[]) => void;
  sorting: SortType;
  setSorting: (sortType: SortType) => void;
  thematicsFilter: string;
  setThematicsFilter: (filter: string) => void;
  parentRef: RefObject<HTMLDivElement>;
  closeMenu: () => void;
  onClick: (label: string) => void;
}

const MenuMobileSecondLevel: FunctionComponent<Props> = ({
  item,
  setMenuSelectedPath,
  menuSelectedPath,
  sorting,
  thematicsFilter,
  setThematicsFilter,
  parentRef,
  closeMenu,
  onClick
}) => {
  const isThematicsCategory = item.key == ROOT_THEMATICS_KEY;
  const isProductsCategory = item.key == ROOT_PRODUCTS_KEY;
  const items = item.children ?? [];
  const sortedItems = isProductsCategory ? sortItems(sorting, items) : items;
  const filteredItems = isThematicsCategory
    ? sortedItems.filter(item => thematicsFilter == '' || item.thematicFilters?.includes(thematicsFilter))
    : sortedItems;

  return (
    <>
      {item.key != ROOT_PRODUCTS_KEY && <MenuSeeAllOption item={item} closeMenu={closeMenu} />}
      {isThematicsCategory && (
        <MenuThematicsOptions item={item} thematicsFilter={thematicsFilter} setThematicsFilter={setThematicsFilter} parentRef={parentRef} />
      )}
      <MobileItemsContainer>
        {filteredItems?.map((item: MenuItem, index: number) => (
          <StyledItem key={index}>
            <StyledMenuListItem
              onClick={() => onClick(item.label)}
              withImages={false}
              withIcons={false}
              item={item}
              setMenuSelectedPath={setMenuSelectedPath}
              currentMenuPath={menuSelectedPath}
              menuSelectedPath={menuSelectedPath}
              displayMode={DisplayMode.list}
              hidePatch={isThematicsCategory}
              displayProductsAmount={isThematicsCategory}
              closeMenu={closeMenu}
            />
            <img src={rightChevron} className="navigate" alt="navigate" />
          </StyledItem>
        ))}
      </MobileItemsContainer>
    </>
  );
};

const StyledMenuListItem = styled(MenuListItem)``;

const StyledItem = styled.div`
  font-size: 14px;
  text-transform: none;
  width: auto;
  position: relative;
  .navigate {
    position: absolute;
    right: 0px;
    top: 8px;
  }
`;

const MobileItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  // padding: 20px 0;
  row-gap: 16px;
  flex: 1;
  overflow-y: auto;
`;

export default MenuMobileSecondLevel;
